export enum PersonRatingGridLevel {
  NONE = "NONE",
  GREEN = "GREEN",
  YELLOW = "YELLOW",
  RED = "RED",
  LEAD = "LEAD",
}
